interface WeChatType {
	oauth: () => string;
}
interface CryptoType {
	publickey: string;
}
interface CookieType {
	expires: string;
	name: string;
	path?: string;
}
interface MonitorType {
	autoView: boolean;
	url: string;
	user_name: string;
}
interface JssdkType {
	url: string;
	jsApiList: string[];
}
export interface ConfigType {
	appid: string;
	storagePrefix?: string;
	wechat: WeChatType;
	crypto: CryptoType;
	monitor: MonitorType;
	jssdk: JssdkType;
}

const config: ConfigType = {
	appid: 'wxed5f55d8e406fab6', // 公众号appid
	storagePrefix: `${process.env.VUE_APP_BLUE_DOT ? `${process.env.VUE_APP_BLUE_DOT}-` : ''}8cb4ad81-`, // node识别自动生成uuid
	wechat: {
		oauth: function () {
			const website_url = encodeURIComponent(window.location.href);
			return `https://se.blue-dot.com.cn/schneider-truck-minisite-api/platform/wechat/auth?website_url=${website_url}`;
		}
	},
	jssdk: {
		url: '/platform/wechat/jssdk',
		jsApiList: ['onMenuShareTimeline', 'updateTimelineShareData', 'onMenuShareAppMessage', 'updateAppMessageShareData', 'hideMenuItems']
	},
	crypto: {
		publickey: `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA1ENbcKJjmH/se9LF3qTX
UBeU/sQb3HcnpnJ/xu5gaADW2CJGuK8WPSgbeX9TkMmzMLYRoPxquez/2c/6oqWc
SgrD0AnXKU0LuSzlNNXIkSOJsDrU9Ma/2UjX1kmZ/roiqdCLsVZO2AEHuPcUZQxw
MosJUYjMN0kzy1ZA8YSPPHmkE9m+zkbUNjoFkbF1vQAd2LPP6FY0lKY1gYaep+xG
ohglyCwiGA9SVBMcwmsffQZDs+1MK2KIDrYq4PisigdsRiRCo23WA0vshHJ9jKwz
hdE2EC9AW79oKySgRpgfxNCbLHcK2MmNSzufL5/6TWNOWEbYkoZ/rW1/Tey8DDrK
ROVIgHEXNy6rn/y2eyCDTk3ekiw31+0umQa1fwyd7Dxad6/PIvr27fOS5MIW2LzD
LqGtuaOr2yo3e3lctHbZOXuZO18AFuGd5rSG6wFjkLTzKJofAx6Sj97x2/AFWwD3
Nuq7R3vLBry9FvAv9m5Ye+GVV5y9tZHKRqhx59scNybjgngWDjpc/ujf/0To/BLM
hwnmxxnsMyKUM6n31M7vuO1eQ2+vydc+3LoBCrjFg2PZexdnyOYdvxNKVubFUSvn
IB/kz5YgCEy/e86Zj4OCFUHfOz1Jfr0/xtBK+xUugErfbUu8eci49G5uZKNre5iI
8Y5g9OCUm8CBKWddvaSfPncCAwEAAQ==
-----END PUBLIC KEY-----`
	},
	monitor: {
		// 这些信息全部向后台要
		autoView: true, // 是否开启页面自动监测
		url: '/platform/analysis/monitor',
		user_name: ''
	}
};

export default config;
